import React from 'react';
import { NavBar } from '../../Modules/Navigation/components/NavBar/NavBar';
import { useUserClients } from '../../contexts/UserClientsContext';
import ClientTiktokAudios from '../../Modules/TikTok/audios/features/explore/ClientTiktokAudios/ClientTiktokAudios';
import { AudioPlayerProvider } from '../../Modules/AudioPlayer/AudioPlayerContext';
import LoadingSpinner from '../../SharedComponents/LoadingSpinner/LoadingSpinner';
import styles from './ClientPages.module.css';
import Card from '../../ui/Card/Card';

const ClientAudiosPage = () => {
    const { selectedClient, clientsInitialized, hasErrorLoadingClients } = useUserClients();

    return (
        <AudioPlayerProvider>
            <NavBar />
            <Card className={styles.content}>
                {clientsInitialized && selectedClient && (
                    <ClientTiktokAudios key={selectedClient.id} clientId={selectedClient.id} />
                )}
                {!clientsInitialized && !hasErrorLoadingClients && <LoadingSpinner spinnerClassName={styles.spinner} />}
                {!clientsInitialized && hasErrorLoadingClients && (
                    <div className={styles.errorMessage}>Sorry, we're experiencing technical issues</div>
                )}
            </Card>
        </AudioPlayerProvider>
    );
};

export default ClientAudiosPage;
